<template>
  <div class="login">
    <div class="login-container">
      <div class="login-logo">
        <!-- <img src="../../assets/images/logo.png" class="logo" alt="" /> -->
        {{ $t('app_name') }}
      </div>
      <div class="login-wrapper">
        <div class="login-title">{{ $t('account') }}</div>
        <el-form :model="loginForm" status-icon  ref="loginForm">
          <el-form-item prop="account">
            <el-input
              type="text"
              v-model="loginForm.account"
              :placeholder="$t('inputaccount')"
            >
              <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 5px" prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              :placeholder="$t('inputpassword')"
            >
              <i slot="prefix" class="el-input__icon el-icon-key"></i>
            </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 30px;">
            <el-button type="primary" @click="goToLogin"
              >{{$t('toLogin')}}</el-button
            >
            <!-- <fieldset class="divider">
              <legend>or</legend>
            </fieldset>
            <el-button>JAccount登录</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script src="https://turing.captcha.qcloud.com/TCaptcha.js"></script>
<script>
import { apiLogin } from "../../plugins/api";
export default {
  data() {
    return {
      loginForm: {
        account: "",
        password: "",
      },
    };
  },
  methods: {
    async toLogin(ticket,randstr) {
      let _data = this.loginForm;
      _data.randstr=randstr;
      _data.ticket=ticket;
      let res = await apiLogin(_data);
      if (res.code === 200) {
        window.localStorage.setItem("app_review_token", res.data.access_token);
        this.$router.push('/')
      } else {
        this.$message.error(res.message);
      }
    },
    goToLogin(){
      if (!this.loginForm.account) {
				this.$message.error(this.$t('accountNotEmpty'));
				return;
			}
      if (!this.loginForm.password) {
				this.$message.error(this.$t('passwordNotEmpty'));
				return;

			}
      try {
				// 生成一个验证码对象
				// CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
				//callback：定义的回调函数
				var captcha = new TencentCaptcha('199772490', this.captchaCallback, {
					// type:'embed'
				});
				// 	// 调用方法，显示验证码
				captcha.show();
			} catch (error) {
				// 加载异常，调用验证码js加载错误处理函数 
				// this.loadErrorCallback();
				console.log(error)
			}
    },
    // 定义回调函数
		captchaCallback(res) {
			if (res.ret === 0) {
                this.toLogin(res.ticket,res.randstr)
            } else {
				if (res.ret !== 2) {
					this.$message.error(res.errorMessage)
				}
			}
		},
  },
};
</script>
<style scoped>
@import "../../assets/scss/login.scss";
</style>
